import { StyledTableHeader, StyledTableRow } from '../../../../shared/styles/components/table.styles';
import { Table, flexRender } from '@tanstack/react-table';

import { Item } from '../../types/item.types';
import { TableHeader as SkapaTableHeader } from '@ingka/table';
import { SortLabel } from './SortLabel';
import { StyledTooltip } from '../../../../shared/styles/components/integrations.styles';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useSorting } from '../../state/sorting.state';

type TableHeaderProps = {
   instance: Table<Item>;
};

export const TableHeader = ({ instance }: TableHeaderProps) => {
   const headerGroups = instance.getHeaderGroups();
   const { toggleSort, isColumnSortedDesc } = useSorting();

   return (
      <SkapaTableHeader sticky={true}>
         {headerGroups.map((headerGroup) => (
            <StyledTableRow key={headerGroup.id}>
               {headerGroup.headers.map((header, index) => {
                  const isCheckboxColumn = header.id === 'select';

                  return (
                     <StyledTableHeader
                        {...(!isCheckboxColumn && header.column.getCanSort() ? { onClick: () => toggleSort(header.id) } : {})}
                        colSpan={header.colSpan}
                        key={header.id}
                        width={header.column.columnDef.meta?.width}
                     >
                        <StyledTableHeaderDiv
                           key={header.id}
                           className={
                              isCheckboxColumn
                                 ? 'checkbox-column'
                                 : (header.column.columnDef.meta?.rightAligned ? 'align-right' : '')
                           }
                        >
                           {isCheckboxColumn ? (
                              flexRender(header.column.columnDef.header, header.getContext())
                           ) : (
                              <StyledTooltip title={index !== 0 ? 'Toggle sort' : ''} placement="top">
                                 <StyledHeaderSpan index={index} rightAligned={header.column.columnDef.meta?.rightAligned}>
                                    {flexRender(header.column.columnDef.header, header.getContext())}
                                    {header.column.getCanSort() && <SortLabel isSortedDesc={isColumnSortedDesc(header.id)} />}
                                 </StyledHeaderSpan>
                              </StyledTooltip>
                           )}
                        </StyledTableHeaderDiv>
                     </StyledTableHeader>
                  );
               })}
            </StyledTableRow>
         ))}
      </SkapaTableHeader>
   );
};

const StyledTableHeaderDiv = styled.div`
   min-height: 24px;
   display: flex;
   align-items: center;
   white-space: normal;
   word-break: normal;
   overflow-wrap: break-word;

   &.align-right {
      justify-content: end;
   }

   &.checkbox-column {
      justify-content: center;
      padding: 0;
   }
`;


const StyledHeaderSpan = styled.span<{ index: number; rightAligned?: boolean }>`
   ${(props) => css`
      padding-left: ${props.index === 0 ? '.8rem' : '0'};
   `}
   display: inline-flex;
   align-items: center;
   position: relative;
   width: 100%;
   ${({ rightAligned }) => rightAligned && 'text-align: right;'}
`;
